<template>
    <span v-html="Text"></span>
</template>

<script>
    export default {
        name: 'ScrambleText', 
        data() 
        {
            return {
                Text: this.text,
                TextOriginal: this.text.split(""),
                Length: this.text.length,
                Signs: "&J19230Ô/* ™•¡§™∞ß∆å *!&@($)".split(""),
                Lock: [],
                Counter: 0,
                Timer: null,
                Iterations: 300,
                IsRunning: false,
                LockScramble: 0.40,
                LockRandom: 0.70,
            }
        },
        props: {
            text: {
                type: String,
                required: true,
            },
            playAudio: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
        methods: {
            initScrambleWithText: function(textToSet, lockScram, lockRan)
            {
                if (!this.IsRunning)
                {
                    this.Lock = new Array(this.Length).map(()=> 0);
                    this.Counter = 0;
                    this.Text = textToSet;
                    this.TextOriginal = textToSet.split("");
                    this.LockScramble = lockScram;
                    this.LockRandom = lockRan;
                    this.Timer = setInterval(this.scrambleText, 50);
                }
            },
            initScramble: function ()
            { 
                if (!this.IsRunning)
                {
                    this.Lock = new Array(this.Length).map(()=> 0);
                    this.Counter = 0;
                    this.Timer = setInterval(this.scrambleText, 50);
                }
            },
            scramble: function (textToScramble) 
            {
                let textArray = textToScramble.split("");

                for (let i = 0; i < textArray.length; i++) 
                {

                    if (this.Lock[i] != 1 && Math.random() > this.LockScramble) 
                    {
                        const charIndex = Math.floor(Math.random() * this.Signs.length);
                        textArray[i] = this.Signs[charIndex];
                        if (Math.random() > this.LockRandom)
                        {
                            this.Lock[i] = 1;
                            textArray[i] = this.TextOriginal[i];
                        }
                    }
                }
                return textArray.join("");
            },
            stop: function()
            {
                clearInterval(this.Timer);
                this.Text = this.text;
                this.Counter = 0;
                this.IsRunning = false;
                this.Lock = new Array(this.Length).map(()=> 0);
            },
            scrambleText: function () 
            {
                let sum = 0;
                for (let i=0; i < this.Lock.length; i++)
                {
                    sum += this.Lock[i];
                }

                if (this.IsRunning && (this.Counter > this.Iterations || sum == this.Length)) 
                {
                    clearInterval(this.Timer);
                    this.Text = this.text;
                    this.Counter = 0;
                    this.IsRunning = false;
                    this.Lock = new Array(this.Length).map(()=> 0);
                } 
                else 
                {
                    this.IsRunning = true;
                    this.Text = this.scramble(this.Text);
                    this.Counter++;
                }
            }
        },
        beforeUnmount() {
            if (this.Timer) {
                clearInterval(this.Timer);
                this.Timer = null;
            }
        }
    }
</script>
